import Timer from './Timer';
import Game from '../../../Game';
import { TimerType } from '../TimerTypes';
import DateHelper from '../../../Utility/DateHelper';
import { TimerActions } from '../../../State/Timer/TimerActions';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { IGameState } from '../../../State/Game/IGameState';
import { shopGiftReward } from '../../../Constants/Economy';

export default class ShopGiftTimer extends Timer {
    public complete(): void {
        PlayerActions.completeShopGiftTimer();
        this.onComplete();
    }
    public onUpdate(state: IGameState = Game.store.getState()) {
        if (
            this.getDate(state) === null &&
            state.playerState.inventory.shopGift <= 0
        ) {
            TimerActions.updateTimer({
                timer: TimerType.SHOP_GIFT,
                time: DateHelper.now,
            });
        }
    }
    public onComplete(): void {}
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        return (
            DateHelper.now.getTime() - this.getDate(state).getTime() >
            DateHelper.Hour * shopGiftReward.cooldownTimer
        );
    }

    public getDate(state: IGameState = Game.store.getState()): Date {
        return state.playerState.timers.get(TimerType.SHOP_GIFT);
    }
}
